export enum TipoConfiguracionPregunta {
  ConfiguracionFormula,
  ConfiguracionCondicion,
  ConfiguracionCondicionBloqueo
}
